__turbopack_context__.v({
  "donutChart": "unaxPG_donutChart",
  "donutChart__center": "unaxPG_donutChart__center",
  "donutChart__centerLabel": "unaxPG_donutChart__centerLabel",
  "donutChart__centerSubLabel": "unaxPG_donutChart__centerSubLabel",
});
